import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time.vue';
import OptionThreshold from '@blade-sxp/task-management/components/option-threshold.vue';
import FrequencyAndThreshold from '@blade-sxp/task-management/components/frequency-threshold.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdDensity = class CrowdDensity extends Vue {
    taskType = '';
    name = '';
    status = 'ENABLE';
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = {
        start: '',
        end: '',
    };
    dayOfWeeks = [];
    alertInterval = 10;
    isLegitimate = false;
    type = 'add';
    id = '';
    isError = false;
    isDetail = false;
    loading = true;
    critical = 0;
    major = 0;
    minor = 0;
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            this.getData();
        }
    }
    mounted() {
        const taskType = this.$route.query.taskType;
        if (taskType) {
            this.taskType = taskType;
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
        }
        else {
            this.submit();
        }
    }
    submit() {
        const params = {
            taskName: this.name,
            taskStatus: this.isError ? 'ERROR' : this.status,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                notifyConfig: {
                    //  enabledAlarmLevels: [this.level],
                    frequency: {
                        unit: 'MINUTE',
                        value: this.alertInterval,
                    },
                },
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: [this.effectiveTimes],
                        effectiveDates: [this.effectiveDates],
                        // levelConfig: {
                        //   [this.level.toLowerCase()]: this.alertInterval,
                        //   unit: 'PERCENT'
                        // },
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
            });
        }
        //  this.cancel();
    }
    fromDataDeviceConfig() {
        const roiData = cloneDeep(DeviceIdDataModule.deviceFromData);
        const config = [];
        if (!isEmpty(roiData)) {
            roiData.forEach((item) => {
                const { zoneId, deviceId, incidentType, roi } = item;
                let persons = [];
                let rawRoi = [];
                let twinRoi = [];
                if (!isEmpty(roi)) {
                    roi.forEach((item) => {
                        if (item.type === 'MAP') {
                            item.data.forEach((item) => {
                                const { mapId, roi } = item;
                                roi[0]?.vertices.shift();
                                twinRoi.push({
                                    twinRoi: {
                                        vertices: roi[0]?.vertices,
                                        id: this.taskId(),
                                        name: mapId,
                                    },
                                });
                            });
                        }
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'ROI') {
                            item.data.forEach((item) => {
                                const { vertices, id } = item;
                                vertices.shift();
                                rawRoi.push({
                                    rawRoi: {
                                        vertices,
                                        id: this.taskId(),
                                        name: id,
                                    },
                                });
                            });
                        }
                    });
                }
                let data = {
                    crowdDensityConfig: {
                        roiMappings: [...rawRoi, ...twinRoi],
                    },
                    labelPersons: persons,
                    zoneId,
                    deviceId,
                    incidentType,
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    cancel() {
        this.$router.push('/tasklist');
    }
    getData() {
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status }) => {
            this.name = name;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdDensity.prototype, "init", null);
CrowdDensity = __decorate([
    Component({
        name: 'CrowdDensity',
        components: {
            'st-device-darwer': DeviceDarwer,
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'option-threshold': OptionThreshold,
            'frequency-and-threshold': FrequencyAndThreshold,
            'button-box': ButtonBox,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    alert: 'Alert Notification',
                },
                zh: {
                    alert: '告警通知',
                },
            },
        },
    })
], CrowdDensity);
export default CrowdDensity;
